export default "/assets/images/cc-filter-room-01.b20fdfb961711255.png";